import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=431235c8&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('431235c8')) {
      api.createRecord('431235c8', component.options)
    } else {
      api.reload('431235c8', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=431235c8&", function () {
      api.rerender('431235c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/consign/detail.vue"
export default component.exports